// extracted by mini-css-extract-plugin
export default {"wrapper":"Competitors_wrapper__w1lSY"};